// Pure helpers shared by the Backtest Studio — extracted so the run-history
// re-open logic is unit-testable without a DOM (see __tests__/).

// Map a persisted run's meta (mode or runType) to the matching studio tab.
export const RUN_TYPE_TO_TAB = {
  optimize: 'optimize',
  montecarlo: 'montecarlo',
  walkforward: 'walkforward',
  portfolio: 'portfolio',
  research_train: 'ml',
  research_sweep: 'ml',
};

/**
 * Resolve which studio tab a re-opened run belongs to.
 * @param {{mode?:string, runType?:string}} meta  the run's meta
 * @param {string} fallbackTab  current tab if we can't tell
 * @param {string[]} tabKeys    valid tab keys (e.g. MODES keys)
 * @returns {string}
 */
export function resolveRunTab(meta = {}, fallbackTab = 'rules', tabKeys = []) {
  const raw = (meta?.mode || meta?.runType || '').toLowerCase() || null;
  if (raw && tabKeys.includes(raw)) return raw;
  if (raw && RUN_TYPE_TO_TAB[raw]) return RUN_TYPE_TO_TAB[raw];
  return fallbackTab;
}

// Low-balance threshold for the "Add credits" banner / meter CTA.
export const LOW_CREDIT_THRESHOLD = 2;

export function isLowCredit(wallet) {
  return wallet != null && wallet.balanceUsd != null && wallet.balanceUsd < LOW_CREDIT_THRESHOLD;
}

export const DEFAULT_OPTIMIZE_PARAMETER = 'config.default_max_hold_bars';

// History changes only when a run reaches a terminal state. Polling an active
// run must not refetch the full history list every few seconds.
export function shouldRefreshHistoryForRun(run) {
  return Boolean(run && ['complete', 'error', 'failed', 'cancelled'].includes(run.status));
}

export function historyMetaText(run) {
  if (run?.summary?.kind === 'derivative') return run.summary.label || run.status || '';
  if (run?.summary) return `${Number(run.summary.totalReturn ?? 0).toFixed(2)}% · ${run.summary.trades ?? 0} trades`;
  return run?.status || '';
}
